import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AddCommentAmountExpenseReportType } from "../../../domain/models/expense-dashboard/add-comment-amount-expense-report";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteAddCommentAmountExpenseReport } from "../../../data/usecases/expense-dashboard/remote-add-comment-amount-expense-report";

export interface AddCommentAmountExpenseReportInterface {
  AddCommentAmountExpenseReportState: FetchState;
  addCommentAmountExpenseReport: Function;
}

const initialStates = {
  AddCommentAmountExpenseReportState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useAddCommentAmountExpenseReportSlice: StateCreator<
  AddCommentAmountExpenseReportInterface
> = (set, get) => ({
  ...initialStates,
  addCommentAmountExpenseReport: async (
    payload: AddCommentAmountExpenseReportType
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddCommentAmountExpenseReport =
      new RemoteAddCommentAmountExpenseReport(
        `${BASE_URL}${Endpoints.ADD_COMMENT_AMOUNT_EXPENSE_REPORT}`,
        axiosHttpClient
      );

    let result = await remoteAddCommentAmountExpenseReport.update(payload);
    return result;
  },
});
